import React from 'react';
import { Moon, Sun, Rocket, Hash, BookOpen } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Link, useLocation } from 'react-router-dom';
import ShareButton from './ShareButton';

const Header = () => {
  const { theme, setTheme } = useTheme();

  return (
    <header className="w-full py-4 md:py-6 flex justify-between items-center border-b border-border bg-background/50 backdrop-blur-sm sticky top-0 z-50 px-4 md:px-6 lg:px-12">
      <a href="/" className="flex items-center gap-2 md:gap-3 cursor-pointer group">
        <div className="bg-gradient-to-br from-purple-500 to-indigo-600 text-white p-2 md:p-2.5 rounded-xl shadow-lg group-hover:scale-105 transition-transform">
          <Rocket size={20} strokeWidth={2.5} fill="currentColor" className="text-white md:w-[22px] md:h-[22px]" />
        </div>
        <h1 className="text-xl md:text-2xl font-heading font-extrabold tracking-tight">
          <span className="hidden sm:inline">SuperTags</span>
          <span className="sm:hidden">ST</span>
        </h1>
      </a>
      
      <div className="flex items-center gap-1 md:gap-2">
        <Link 
            to="/blog" 
            className="flex items-center gap-1.5 md:gap-2 px-3 md:px-4 py-2 text-sm font-bold text-muted-foreground hover:text-foreground transition-colors min-h-[44px]"
        >
            <BookOpen size={18} className="md:w-4 md:h-4" />
            <span>Blog</span>
        </Link>

        <div className="flex items-center gap-1 border-l border-border pl-2 md:pl-3">
            <ShareButton />
            <button
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            className="p-2.5 md:p-2 hover:bg-secondary transition-colors rounded-full border border-transparent hover:border-border min-h-[44px] min-w-[44px] flex items-center justify-center"
            data-testid="theme-toggle"
            aria-label="Toggle theme"
            >
            <span className="sr-only">Toggle theme</span>
            {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
            </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
